import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
// ignore-string-externalization
import React from "react";
import { // @ts-expect-error __HistoryContext is missing from types
__HistoryContext as HistoryContext, __RouterContext as RouterContext } from "react-router";
import { createNextRouterHistory } from "./history";
/** Enables using react-router in next.js on the client-side */ export function BrowserRouter(param) {
    var children = param.children;
    var ref = _sliced_to_array(React.useState(createNextRouterHistory), 1), history = ref[0];
    // https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/Router.js#L60-L72
    return /*#__PURE__*/ _jsx(RouterContext.Provider, {
        value: {
            history: history,
            location: history.location,
            match: {
                path: "/",
                url: "/",
                params: {},
                isExact: history.location.pathname === "/"
            }
        },
        children: /*#__PURE__*/ _jsx(HistoryContext.Provider, {
            value: history,
            children: children
        })
    });
}
